import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Styles from './Review.css';

class EditReviewConfirmModal extends Component {
  render() {
    return (
      <div>
        <Modal
          style={{ top: '0px' }}
          show={this.props.show}
          onHide={this._onClickClose}
          container={this}
          backdrop="static"
          dialogClassName={Styles['modal-dialog']}
        >
          <Modal.Header className={Styles['modal-header-danger']} closeButton>
            <Modal.Title style={{ fontSize: '19px', fontWeight: '300' }}>
              <div>Edit Loyalty Program</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={`${Styles['modal-body']} top10 bottom10`}>
            Are You sure you want to edit the loyalty program? After you save,
            the changes will be implemented immediately to all outlet.
            <br />
            <br />
            All the points and rewards redeemed by customer will not be changed.
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              style={{ width: '100px' }}
              className="btn btn-default"
              onClick={this._onClickClose}
            >
              Cancel
            </button>
            <button
              type="button"
              style={{ width: '100px' }}
              className="btn btn-danger"
              onClick={this._onClickEdit}
            >
              OK
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  _onClickClose = e => {
    e.stopPropagation();
    this.props.close();
  };

  _onClickEdit = e => {
    e.stopPropagation();
    this.props.confirmEdit();
  };
}

export default EditReviewConfirmModal;
